import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { cloneAlphaFromContent } from '../../actions/EditorActions/EditorActions';
import analytics from '../../shared/services/analytics/analytics';
import {
  alphaDetailSelector,
  alphasOptionsSettingsChildrenSelector,
  alphasTeamOwnerSelector,
} from '../../reducers/AlphasReducer/AlphasSelector';
import { expressionOperatorsSelector } from '../../reducers/ExpressionLanguageReducer/ExpressionLanguageSelector';
import { fastExpressionOperatorsSelector } from '../../reducers/FastExpressionLanguageReducer/FastExpressionLanguageSelector';
import { isAlphaCreatedByTheCurrentUserSelector } from '../../reducers/GenericSelectors';
import {
  languageComboIdsSelector,
  languageFieldIdsSelector,
  languageSelectionIdsSelector,
} from '../../reducers/LanguageFieldsReducer/LanguageFieldsSelector';
import { editorWillMountMonaco } from '../../shared/helpers/monaco-helper';
import { useAppDispatch } from '../../shared/services/store/useAppDispatch';

import { AlphaCode } from './AlphaCode';

interface AlphaCodeContainerProps {
  id?: string;
}

const AlphaCodeContainer = (props: AlphaCodeContainerProps) => {
  const { id } = props;
  const history = useHistory();
  const dispatch = useAppDispatch();

  // @ts-ignore
  const alpha: any = useSelector(alphaDetailSelector);
  // @ts-ignore
  const expressionOperators: any = useSelector(expressionOperatorsSelector);
  // @ts-ignore
  const fastExpressionOperators: any = useSelector(fastExpressionOperatorsSelector);
  // @ts-ignore
  const settingsOptions: any = useSelector(alphasOptionsSettingsChildrenSelector);
  // @ts-ignore
  const isAlphaCreatedByTheCurrentUser: boolean = useSelector(isAlphaCreatedByTheCurrentUserSelector);
  // @ts-ignore
  const userIdFromAlpha: string = useSelector(alphasTeamOwnerSelector);
  // @ts-ignore
  const languageFieldsRegularIds: string[] = useSelector(languageFieldIdsSelector);
  // @ts-ignore
  const languageFieldsSelectionIds: string[] = useSelector(languageSelectionIdsSelector);
  // @ts-ignore
  const languageFieldsComboIds: string[] = useSelector(languageComboIdsSelector);

  const dispatchCloneAlphaFromContent = useCallback(
    (alphaDetail: any) => {
      dispatch(cloneAlphaFromContent(alphaDetail));
    },
    [dispatch]
  );

  const handleCloneAlphaFromContent = () => {
    analytics.trackCustomEvent('alphas_click_clone_alpha');
    history.push('/simulate');
    dispatchCloneAlphaFromContent(alpha);
  };

  const ORIGIN_DISPLAY_NAMES: Record<string, string> = {
    BRAINLABS: 'BRAIN Labs',
    PLATFORM: 'BRAIN Platform',
  };
  const originRaw: string = alpha?.get('origin') ?? '';
  const originDisplay = ORIGIN_DISPLAY_NAMES[originRaw] ?? originRaw;

  const regularCode = alpha?.getIn(['regular', 'code']);
  const comboCode = alpha?.getIn(['combo', 'code']);
  const selectionCode = alpha?.getIn(['selection', 'code']);
  const hasCode = !!(regularCode || comboCode || selectionCode);

  const isOwner = isAlphaCreatedByTheCurrentUser;
  const disabled = !isOwner || !hasCode;

  const message = isOwner
    ? { id: 'alpha.code.cannot.view.code.withOrigin', values: { origin: originDisplay } }
    : { id: 'alpha.code.cannot.view.code.noUser', values: {} };

  return (
    alpha && (
      <div className="alphas-details-content__box" id={id}>
        <AlphaCode
          alpha={alpha}
          codeElem="code-sample-content"
          editorWillMount={editorWillMountMonaco({
            expressionOperators,
            fastExpressionOperators,
            languageFieldsRegularIds,
            languageFieldsSelectionIds,
            languageFieldsComboIds,
          })}
          handleCloneAlphaFromContent={handleCloneAlphaFromContent}
          id={id}
          settingsOptions={settingsOptions}
          disabled={disabled}
          message={message}
          userIdFromAlpha={userIdFromAlpha}
        />
      </div>
    )
  );
};

export default AlphaCodeContainer;
